/* Carte expertise — activation au passage du MILIEU de l'écran.
   Les états de survol de la carte (image révélée, lueur, filet réveillé,
   flèche, libellé lettre à lettre) n'existent pas au doigt : sur les
   écrans sans survol, la carte qui traverse la bande centrale de la
   fenêtre reçoit is-in-view, et le CSS rejoue ces états — bloc
   @media (hover: none) de mm-expertise-card.css, mêmes valeurs, mêmes
   courbes.

   La BANDE CENTRALE, pas un taux de visibilité : un seuil de surface
   allumait deux ou trois cartes à la fois sur les grands écrans — or
   l'effet remplace le survol, qui n'éclaire qu'une carte. La bande
   (24 % de la hauteur, autour du milieu) n'est traversée que par une
   carte à la fois — deux, brièvement, à la passation : le fondu croisé
   fait la transition. La classe repart quand la carte quitte la bande :
   en remontant la page les cartes se rallument, l'effet raconte la
   position dans la page, pas un état consommé une fois. */
(function () {
	'use strict';

	if (window.__mmExpCardVue) return;
	window.__mmExpCardVue = true;

	function init(root) {
		/* (hover: none) OU largeur mobile — même gate que le bloc CSS : le
		   mode responsive de Safari ne simule pas les media features de
		   pointeur, et une mise en page mobile doit se comporter en mobile
		   même au trackpad. */
		if (!window.matchMedia('(hover: none)').matches && !window.matchMedia('(max-width: 768px)').matches) return;
		if (!('IntersectionObserver' in window)) return;
		var cards = (root || document).querySelectorAll('.mm-exp-card:not([data-mm-vue])');
		if (!cards.length) return;
		var obs = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				entry.target.classList.toggle('is-in-view', entry.isIntersecting);
			});
		}, {
			/* La zone d'intersection est réduite à la bande 38 % → 62 % de la
			   fenêtre : une carte est active tant qu'elle la recouvre. */
			rootMargin: '-38% 0px -38% 0px'
		});
		Array.prototype.forEach.call(cards, function (card) {
			card.setAttribute('data-mm-vue', '');
			obs.observe(card);
		});
	}

	/* L'éditeur de thème recharge des sections entières : on ré-initialise. */
	document.addEventListener('shopify:section:load', function (event) {
		init(event.target);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}
})();
